<!-- SUM UP -->
<ng-container *ngIf="hideSavingsPlan; else fundWithdrawal">
  <div class="header">
    <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.title' | translate }}</h2>
    <app-ui-tooltip [content]="'sp.revamp.infoTooltip.legal' | translate" color="grey" size="small"></app-ui-tooltip>
  </div>
</ng-container>

<ng-template #fundWithdrawal>
  <h3>
    <span class="title">{{ 'sp.revamp.assetGraph.title' | translate }}</span>
    <app-ui-tooltip [content]="'sp.revamp.infoTooltip.legal' | translate" color="grey" size="small"></app-ui-tooltip>
  </h3>
</ng-template>

<app-savings-sum-up
  [currentChip]="currentChip"
  [customerInvestment]="customerInvestment"
  [estimatedPeriod]="estimatedPeriod"
  [estimatedValues]="estimatedValues"
  [language]="customer.language"
  [newMonthlyValue]="newMonthlyValue"
  [kind]="currentAccount.kind"
></app-savings-sum-up>

<!-- CHART TABS and D3 -->
<div class="tab-years">
  <div
    *ngFor="let option of [5, 10, 15, 20, 30]"
    class="tab"
    [class.active]="estimatedPeriod === option"
    (click)="
      calculateChartData(option); amplitudeTrack('Savings Plan Engaged', { savings_plan_time_horizon: option + 'y', kind: currentAccount.kind })
    "
  >
    {{ 'sp.revamp.assetGraph.y' | translate: { years: option } }}
  </div>
</div>

<div class="range-chart" #chartContainer>
  <svg></svg>
  <app-savings-chart-tooltip
    [currency]="currentAccount.currency"
    [kind]="currentAccount.kind"
    [language]="customer.language"
    [tooltipData]="tooltipData"
  ></app-savings-chart-tooltip>
</div>

<!-- CHART CHIPS -->
<div *ngIf="!hideSavingsPlan" class="deposit-chips">
  <div
    class="deposit-chips-item"
    *ngFor="let item of ['expectedCaseWithout', 'expectedCase']; let i = index"
    (click)="switchSelection(i); track(i)"
    [class.inactive]="currentChip !== i"
    [class.without]="i === 1"
  >
    {{ 'sp.revamp.assetGraph.option.' + (i === 0 ? 'monthlyDeposits' : 'noMonthlyDeposits') | translate }}
  </div>
</div>

<!-- DEPOSIT INPUT and DIALOG -->
<app-savings-deposit
  *ngIf="!hideSavingsPlan"
  [appLocation]="customer?.app_location"
  [currency]="customerInvestment?.currency"
  [language]="customer?.language"
  [newSavings]="customerInvestment?.monthly_investment"
  [kind]="currentAccount.kind"
  (changeValue)="onChangeValue($event)"
  (setDeposit)="onSetDeposit($event)"
></app-savings-deposit>

<!-- SOCIAL PROOF and MORE EXPLANATION -->
<app-social-proof
  [currency]="customerInvestment?.currency"
  [estimatedPeriod]="estimatedPeriod"
  [estimatedValues]="estimatedValues"
  [expectedPercentages]="expectedPercentages"
  [language]="customer?.language"
  [savingsPlanSocialProof]="savingsPlanSocialProof"
  [showDetails]="showDetails"
  [hideSavingsPlan]="hideSavingsPlan"
  (toggleDetails)="toggleDetails($event)"
></app-social-proof>
